import { Component, OnInit } from '@angular/core';
import { LoggedinService } from '../../services/login/loggedin.service';
import { SessionHelper } from '../../shared/services/localstorage';
import { BaseService } from '../../services/base/base.service';
import {Menus} from '../../models/menus/menus';
import { roleID } from '../../configurations/configuration';
@Component({
  selector: 'app-side-nav',
  templateUrl: './side-nav.component.html',
  styleUrls: ['./side-nav.component.scss']
})
export class SideNavComponent implements OnInit {
   menu:Menus;
   userInfo: any;
   roleID = roleID;
   showLoader: boolean = true;
  constructor(public loggedinService:LoggedinService, private baseService: BaseService) {
    this.menu = new Menus();
    console.log("Menus", this.menu)
   }
   activeMenu:any;
  ngOnInit() {
    this.showLoader = true;
    if(SessionHelper.isLoggedIn()) {
      this.loggedinService.currentStatus.subscribe((result:boolean)=>{
      if(result){
        this.userInfo= SessionHelper.getSession();
        console.log("userInfo", this.userInfo);
        this.baseService.getMenus(this.userInfo.role_id).subscribe((menus:any)=>{
          console.log(menus.data);
          this.showLoader = false;
          this.activeMenu=menus.data;
          this.menu.upcomingEventFilter = true;
          this.menu.notificationsFilter = true;
          for(let i=0;i<this.activeMenu.length;i++){
                console.log("this.activeMenu", this.activeMenu[i].display_name=='display_name');
                if( this.activeMenu[i].display_name === 'Dashboard') {
                  this.menu.dashboard=true;
                }
                else if(this.activeMenu[i].display_name === "Create Event") {
                  this.menu.createEvent = true;
                }
                else if(this.activeMenu[i].display_name === "My Events") {
                  this.menu.myEvents = true;
                }
                else if(this.activeMenu[i].display_name === "Speaker") {
                  this.menu.Speaker = true;
                }
                else if(this.activeMenu[i].display_name === "Training") {
                  this.menu.Training = true;
                }
                else if(this.activeMenu[i].display_name === "Reference Materials") {
                  this.menu.uploadReferenceMaterial = true;
                }
                else if(this.activeMenu[i].display_name === "Manage Speaker Content") {
                  this.menu.manageSpeakerContent = true;
                }
                else if(this.activeMenu[i].display_name === "Venue") {
                  this.menu.venue = true;
                }
                else if(this.activeMenu[i].display_name === "Attendee List") {
                  this.menu.attendeeListing = true;
                }
                else if(this.activeMenu[i].display_name === "Reports") {
                  this.menu.reports = true;
                }
                else if(this.activeMenu[i].display_name === "Reconcile Program") {
                  this.menu.reconcileExpense = true;
                }
                else if(this.activeMenu[i].display_name === "My Profile") {
                  this.menu.myProfile = true;
                }
                else if(this.activeMenu[i].display_name === "Search Speaker") {
                  this.menu.searchSpeaker = true;
                }
                else if(this.activeMenu[i].display_name === "Add Speaker") {
                  this.menu.addSpeaker = true;
                }
                else if(this.activeMenu[i].display_name === "Search Venue") {
                  this.menu.searchVenue = true;
                }
                else if(this.activeMenu[i].display_name === "Add Venue") {
                  this.menu.addVenue = true;
                  this.menu.editVenue = true;
                }
          }
          console.log(this.menu)
          this.loggedinService.setMenuList(this.menu);
        });
      }
      })
    }
  }

}
